import { TextSmall } from '@/components/Texts';
import React from 'react';

const Foreword = () => {
  return (
    <>
      <TextSmall>
        We, Diment.io together with our subsidiaries (hereinafter collectively:
        <TextSmall as='span' fontWeight={'semibold'}>
          {' '}
          {`"the company" , "we" or "us"`}{' '}
        </TextSmall>
        ) take the protection of your personal data seriously and would like to
        inform you here about data protection in our company.
      </TextSmall>
      <TextSmall>
        {`Within the scope of our responsibility under data protection law,
        additional obligations have been imposed on us by the entry into force
        of the EU General Data Protection Regulation (Regulation (EU) 2016/679;
        hereinafter: "GDPR") in order to ensure the protection of
        personal data of the person affected by a processing operation (we also
        address you as data subject hereinafter with`}
        <TextSmall as='span' fontWeight={'semibold'}>
          {' '}
          {`"customer", "user", "you",
          "you" or "data subject"`}
        </TextSmall>
        ).
      </TextSmall>
      <TextSmall>
        Insofar as we decide either alone or jointly with others on the purposes
        and means of data processing, this includes above all the obligation to
        inform you transparently about the nature, scope, purpose, duration and
        legal basis of the processing (cf. Articles 13 and 14 GDPR). With this
        statement (hereinafter:{' '}
        <TextSmall as='span' fontWeight={'semibold'}>
          {' '}
          {`"Privacy Notice"`}
        </TextSmall>
        ), we inform you about the manner in which your personal data is
        processed by us.
      </TextSmall>
      <TextSmall>
        Our data protection notices have a modular structure. It consists of a
        general part for any processing of personal data and processing
        situations that come into play each time a website is called up (A.
        General) and a special part, the content of which relates in each case
        only to the processing situation specified there with the designation of
        the respective offer or product, in particular the visit to websites as
        detailed here (B. Visit to websites).
      </TextSmall>
      <TextSmall>
        To find the parts that are relevant to you, please refer to the
        following overview for the breakdown of the privacy notices:
      </TextSmall>
    </>
  );
};

export default Foreword;
